import Swal from "sweetalert2/dist/sweetalert2";
import { i18n } from "@/i18n";

class NotificationManager {
  alert = null;
  toast = null;
  constructor() {}

  showNotification(type, title, timer = 4000, position = "top-end", showButton = false, customClass = "") {
    this.toast = Swal.mixin({
      toast: true,
      position: position,
      showConfirmButton: showButton,
      timer: timer,
      customClass: {
        popup: customClass,
      },
    });
    return this.toast.fire({
      icon: type,
      title: title,
    });
  }

  showAlert(
    type,
    title,
    subTitle = "",
    closeButton = false,
    cancelButton = false,
    confirmButtonText = null,
    cancelButtonText = null,
    color = "#000",
    containerClass = "",
    html = false,
    allowOutsideClick = true,
  ) {
    this.alert = new Swal({
      icon: type,
      title: title,
      text: html ? null : subTitle,
      html: html ? subTitle : null,
      padding: "2em",
      showCloseButton: closeButton,
      showCancelButton: cancelButton,
      cancelButtonText: cancelButtonText ? cancelButtonText : i18n.global.t("cancel"),
      confirmButtonText: confirmButtonText ? confirmButtonText : i18n.global.t("confirm"),
      color: color,
      customClass: {
        container: containerClass,
      },
      allowOutsideClick: allowOutsideClick,
    });

    const container = document.querySelector(".swal2-container");
    container.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    return this.alert;
  }

  closeAlert() {
    if (this.alert) {
      this.alert.close();
      this.alert = null;
    }
  }
}

export const notificationManager = new NotificationManager();
